import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import luganeseIcon from '../static/images/region_icons/luganese-icon.png';
import mendrisiottoIcon from '../static/images/region_icons/mendrisiotto-icon.png';
import bellinzoneseIcon from '../static/images/region_icons/bellinzonese-icon.png';
import locarneseIcon from '../static/images/region_icons/locarnese-icon.png';
import { setNewFilters } from '../redux/filtersSlice';
import { useTranslation } from 'react-i18next';


const RegionIconSection = () => {
    const { t } = useTranslation();
    const [regions] = useState([
        'Luganese', 'Mendrisiotto', 'Bellinzona e Valli', 'Ascona-Locarno'
    ]);

    // Imposta filtro region prima di passare alla pagina di ricerca
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleRegionClick = (region) => {
        dispatch(setNewFilters({ region: [region] }));
        navigate('/all-activities');
    }
    return (
        <React.Fragment>
            <div className='mt-16 mb-2 w-full lg:w-[1000px]'>
                <h1 className="text-[#225424] hidden xl:block">{t('Homepage.chooseYourRegionTitle')}</h1>
                <h2 className="text-[#225424] hidden md:block xl:hidden">{t('Homepage.chooseYourRegionTitle')}</h2>
                <h3 className="text-[#225424] md:hidden">{t('Homepage.chooseYourRegionTitle')}</h3>
            </div>
            <div className="flex w-full lg:w-[1000px] overflow-x-auto hide-scrollbar">
                <div onClick={() => handleRegionClick(regions[3])} className=''>
                    <img src={locarneseIcon} alt="" className='min-w-36' />
                </div>
                <div onClick={() => handleRegionClick(regions[2])} className=''>
                    <img src={bellinzoneseIcon} alt="" className='min-w-36' />
                </div>
                <div onClick={() => handleRegionClick(regions[0])} className=''>
                    <img src={luganeseIcon} alt="" className='min-w-36' />
                </div>
                <div onClick={() => handleRegionClick(regions[1])} className=''>
                    <img src={mendrisiottoIcon} alt="" className='min-w-36' />
                </div>
            </div>
        </React.Fragment>
    )
}

export default RegionIconSection;